export default {
  REPORT_READY: 'ReportReady',
  CASE_READY: 'CaseReady',
  ISSUES_COUNT_PROCESSED: 'IssuesCountProcessed',
  ENTITY_ASSIGNED: 'EntityAssigned',
  CASE_ASSIGNED: 'CaseAssigned',
  ENTITY_CREATED: 'EntityCreated',
  CASE_CREATED: 'CaseCreated',
  RCU_RECEIVED: 'RCUReceived',
  KYC_REFRESH_ARRIVED: 'KYCRefreshArrived',
  ENTITY_ASSIGNED_NEW_ISSUE: 'EntityAssignedOMIssue',
  CASE_ASSIGNED_OM_ISSUE: 'CaseAssignedOMIssue',
  OM_EXPIRED: 'OMExpired',
  MENTION_IN_COMMENT: 'MentionInComment',
  ENTITY_DELETED: 'EntityDeleted',
  CASE_DELETED: 'CaseDeleted',
  ENTITY_DELETION_FINISHED: 'EntityDeletionFinished',
  CASE_DELETION_FINISHED: 'CaseDeletionFinished',
  ALL_READ: 'AllRead',
  NOTIFICATION_STATUS: 'NotificationStatus',
  OM_EXPIRING: 'OMExpiring',
};
